import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { B03CardManagementPage } from '../b03-card-management/b03-card-management';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { IonicSelectableComponent } from 'ionic-selectable';
/**
 * Generated class for the B03aCardAddPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
interface Port {
  id: number;
  name: string;
}
interface corpInfo{
  CORP_ID: number;
  CORP_NAME: string;
}

@IonicPage()
@Component({
  selector: 'page-b03a-card-add',
  templateUrl: 'b03a-card-add.html',
})
export class B03aCardAddPage {
  ports: Port[] = [];
  port: Port;
  private todo : FormGroup;
  corpArr: corpInfo[] = [];
  corpItems: corpInfo[] = [];
  loading: any;
  Status: any;
  public errorMessage: any = "";

  cardData = {  CARD_NO:'',
                CAR_PLATE:'',  CREDIT_LIMIT:'',
                BALANCE:'', CARD_ACTIVE:'YES', CORP_ID: ''
  }

  constructor(public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, public serviceapi: ServiceApiProvider,
              private toastCtrl: ToastController, public loadingCtrl: LoadingController) {

    this.todo = this.formBuilder.group({
    cardNumber: ['', Validators.required],
    carPlate: ['', Validators.required],
    creditLimit: ['', Validators.required],
    cardActive: ['', Validators.required],
    corporate: ['', Validators.required],
    });

    let tbl = ["All"];
    let column = ["All"];
    let value = ["All"];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];
  
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let sortby= "CORP_NAME";
    let sorttype= "ASC";
    let jsonsort = this.serviceapi.sort(sortby,sorttype);
    let mydata = Object.assign(jsonsort,jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();

    this.serviceapi.readdata(json_data,"CORPORATE","1","1").then((result) => {
      this.loading.dismiss();
      this.Status = result["Message"];
      if (this.Status == '1'){
        
        let Records = result["Records"];
        this.corpArr = Records;
        this.corpItems = this.corpArr;
        let k=0;
          for(k=0;k<(this.corpItems).length;k++)
          {
            let z = {
              id:1,
              name:""
            }
            z.id = this.corpItems[k].CORP_ID;
            z.name = this.corpItems[k].CORP_NAME;
            console.log(z);
            (this.ports).push(z);
          }
          console.log(this.ports);
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B03aCardAddPage');
  }

  saveNewCard(){
    this.showLoader();
    this.cardData.BALANCE = this.cardData.CREDIT_LIMIT;

    this.serviceapi.insertdata("CARD",this.cardData).then((result) => {
      this.Status = result["Message"];

      if (this.Status == "1"){
        this.loading.dismiss();
        this.navCtrl.setRoot(B03CardManagementPage);
      }
      else{
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
    
  }

  cancel(){
    this.navCtrl.pop();
  }

  goTo(){
    this.navCtrl.setRoot(B03CardManagementPage);
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }

  portChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    console.log('port:', event.value);
    this.cardData.CORP_ID = event.value["id"];
  }
}



// WEBPACK FOOTER //
// ./src/pages/b03a-card-add/b03a-card-add.ts